export const isEmptyString = (string) => {
  return string === ''
}
